import { client } from './client'
import {
  AgentCommissionPreview,
  AgentCommissionSettlement,
  AgentOption,
  CreateAgentSettlementPayload
} from '@views/agentCommissions/types'

const headers = (cocap: string) => ({ cocap })

export const getAgentOptions = async (cocap: string): Promise<AgentOption[]> => {
  const response = await client.get('/agent-commissions/agents', {
    headers: headers(cocap)
  })
  return response.data.data
}
export const getAgentCommissionPreview = async (cocap: string, period: string, agentId?: string) => {
  const response = await client.get<AgentCommissionPreview>('/agent-commissions/preview', {
    headers: headers(cocap),
    params: { period, agentId }
  })
  return response.data
}
export const getAgentCommissionSettlements = async (cocap: string, agentId?: string) => {
  const response = await client.get<{ data: AgentCommissionSettlement[] }>('/agent-commissions/settlements', {
    headers: headers(cocap),
    params: { agentId }
  })
  return response.data.data
}
export const getAgentCommissionSettlement = async (cocap: string, settlementId: string) => {
  const response = await client.get<AgentCommissionSettlement>(`/agent-commissions/settlements/${settlementId}`, {
    headers: headers(cocap)
  })
  return response.data
}
export const createAgentCommissionSettlement = async (cocap: string, payload: CreateAgentSettlementPayload) => {
  const response = await client.post<AgentCommissionSettlement>('/agent-commissions/settlements', payload, {
    headers: headers(cocap)
  })
  return response.data
}
export const payAgentCommissionSettlement = async (cocap: string, settlementId: string) => {
  const response = await client.patch<AgentCommissionSettlement>(
    `/agent-commissions/settlements/${settlementId}/paid`,
    {},
    { headers: headers(cocap) }
  )
  return response.data
}
export const cancelAgentCommissionSettlement = async (cocap: string, settlementId: string, reason: string) => {
  const response = await client.patch<AgentCommissionSettlement>(
    `/agent-commissions/settlements/${settlementId}/cancel`,
    { reason },
    { headers: headers(cocap) }
  )
  return response.data
}
